<template>
    <div class="ext">
        <template v-if="data.dir.is_group">
          <template v-if="data.dir.group == 'GROUP'">
            <img src="@/assets/icons/folder/Group.svg" width="60px" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}" />
            <!--<span class="fa fa-folder group-color" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}"></span>-->
          </template>
          <template v-if="data.dir.group == 'PROJECT'">
            <img src="@/assets/icons/folder/Project.svg" width="60px" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}" />
            <!--<span class="fa fa-folder project-color" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}"></span>-->
          </template>
        </template>
        <template v-if="!data.dir.is_group">
          <template v-if="data.dir.group == 'PUBLIC'">
            <img src="@/assets/icons/folder/Public.svg" width="60px" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}" />
            <!--<span class="fa fa-folder project-color" @click="browse(data.index, data.dir)" v-if="data.dir.is_dir" :class="{'fade-folder': !data.dir.is_approved && data.dir.is_group == true}"></span>-->
          </template>
          <template v-if="data.dir.group != 'PUBLIC'">
            <img src="@/assets/icons/folder/General.svg" width="60px" v-if="data.dir.is_dir" @click="browse(data.index, data.dir)" :class="{'public-color': data.dir.is_public}" />
          </template>
          <!--<span class="fa fa-folder" v-if="data.dir.is_dir" @click="browse(data.index, data.dir)" :class="{'public-color': data.dir.is_public}"></span>-->
        </template>
        <span v-if="!data.dir.is_dir && word(data.dir.extname)" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/Doc.svg" width="60px" />
          <!--<img src="@/assets/word.svg" width="80px" /> -->
        </span>
        <span v-if="!data.dir.is_dir && data.dir.extname == '.pdf'" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/PDF.svg" width="60px" />
          <!--<img src='@/assets/icons8-pdf-100.png' width="80px" />-->
        </span>
        <img src="@/assets/icons/icon/Mp3.svg" width="60px" v-if="!data.dir.is_dir && data.dir.type == 'audio'" @click="browse(data.index, data.dir)"></span>
        <span v-if="!data.dir.is_dir && data.dir.type == 'video'" @click="browse(data.index, data.dir)">
          <img src='@/assets/play-video.jpg' />
        </span>
        <span v-if="!data.dir.is_dir && code(data.dir.extname)" class="fa fa-file-code" @click="browse(data.index, data.dir)"></span>
        <span v-if="!data.dir.is_dir && data.dir.extname == '.pub'" @click="browse(data.index, data.dir)"><img src="../assets/pub.png" /></span>
        <span  v-if="!data.dir.is_dir && data.dir.extname == '.zip' || !data.dir.is_dir && data.dir.extname == '.gz' || !data.dir.is_dir && data.dir.extname == '.tar'" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/Rar.svg" width="60px" />
        </span>
        <span v-if="!data.dir.is_dir && data.dir.extname == '.ppt' || data.dir.extname == '.pptx'" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/PPT.svg" width="60px" />
        </span>
        <span v-if="!data.dir.is_dir && excel(data.dir.extname)" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/XLS.svg" width="60px" height="auto" />
        </span>
        <!-- <span v-if="!data.dir.is_dir && data.dir.type == 'image'" @click="browse(data.index, data.dir)">
          <img :src=data.dir.thumbnail />
        </span> -->
         <span v-if="(!data.dir.is_dir && data.dir.extname == '.txt') || (!data.dir.is_dir && data.dir.extname == '')" @click="browse(data.index, data.dir)">
          <img src="@/assets/icons/icon/TXT.svg" width="60px" />
         </span>

          <span v-if="data.dir.extname !== '.zip' && data.dir.extname !== '.tar.gz' && data.dir.extname !== '.ppt' && data.dir.extname !== '.pptx' && !word(data.dir.extname) && data.dir.extname !== '.pdf' && data.dir.type !== 'video' && data.dir.type !== 'audio' && data.dir.type !== 'image' && !data.dir.is_dir && data.dir.extname !== '.txt' && data.dir.extname !== '' && !excel(data.dir.extname) && !code(data.dir.extname)">
          <img src="@/assets/icons/icon/Unkown File.svg"  width="60px" />
         </span>

        <span class="image" v-if="data.showImage  && isImage(data.dir)">
          <img :src="data.dir.thumbnail"  width="100%" />
        </span>

        <span class="image" v-if="data.showImageIcon  && isImage(data.dir)">
          <img src="@/assets/icons/icon/image.svg"  width="100%" />
        </span>
    </div>
</template>
<style lang="css" scoped>
.ext-title img {
  width: 1rem !important;
  margin-right: 0.25rem;
}
</style>
<script>
import cookies from "@/services/cookies";
import moment from "moment";
export default {
  data() {
    return {
      token: cookies.getCookie("token"),
      src: "",
    };
  },
  props: {
    data: {
      dir: Object,
      index: Number
    },
  },
  methods: {
    browse(index, file) {
      this.$parent.browse(index, file);
    },
    isImage(file) {
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }
        return (
          ext.toLowerCase() === "jpg" ||
          ext.toLowerCase() === "png" ||
          ext.toLowerCase() === "PNG" ||
          ext.toLowerCase() === "jpeg" ||
          ext.toLowerCase() === "JPG" ||
          ext.toLowerCase() === "JPEG" ||
          ext.toLowerCase() === "gif" ||
          ext.toLowerCase() === "GIF"
        );
      } catch (err) {
        return false;
      }
    },
    getFileIcon(file) {
      let name = file.split(".");
      let ext = name[name.length - 1];

      if (ext.toLowerCase() === "docx" || ext.toLowerCase() === "doc") {
        return ["fa fa-file-word", true];
      }

      if (ext.toLowerCase() === "xlsx" || ext.toLowerCase() === "xls") {
        return ["fa fa-file-excel", true];
      }

      if (ext.toLowerCase() === "pptx" || ext.toLowerCase() === "ppt") {
        return ["fa fa-file-powerpoint", true];
      }

      if (ext.toLowerCase() === "pdf") {
        return ["fa fa-file-pdf", true];
      }

      if (ext.toLowerCase() === "mp3") {
        return ["fa fa-file-audio", true];
      }

      if (ext.toLowerCase() === "mp4") {
        return ["fa fa-file-video", true];
      }

      if (
        ext.toLowerCase() === "jpg" ||
        ext.toLowerCase() === "png" ||
        ext.toLowerCase() === "PNG" ||
        ext.toLowerCase() === "jpeg" ||
        ext.toLowerCase() === "JPG" ||
        ext.toLowerCase() === "JPEG" ||
        ext.toLowerCase() === "gif" ||
        ext.toLowerCase() === "GIF"
      ) {
        return ["fa fa-file-image", true];
      }

      return ["fa fa-file-alt", true];
    },
    type(is_dir, ext) {
      if (is_dir) {
        return "Folder";
      } else {
        if (ext === "") {
          return "Unknown File";
        } else {
          if (
            ext == ".xls" ||
            ext == ".cvs" ||
            ext == ".csv" ||
            ext == ".xll" ||
            ext == ".xlsb" ||
            ext == ".xlam" ||
            ext == ".xlk" ||
            ext == ".xlsx" ||
            ext == ".xlsm" ||
            ext == ".xltm" ||
            ext == ".xltx"
          ) {
            return "Excel Document";
          }

          if (ext == ".doc" || ext == ".docx") {
            return "Word Document";
          }

          if (
            ext == ".mp3" ||
            ext == ".3pg" ||
            ext == ".aa" ||
            ext == ".aac" ||
            ext == ".aax" ||
            ext == ".act" ||
            ext == ".aiff" ||
            ext == ".amr" ||
            ext == ".ape" ||
            ext == ".au" ||
            ext == ".awb" ||
            ext == ".dct" ||
            ext == ".dss" ||
            ext == ".dvf" ||
            ext == ".flac" ||
            ext == ".gsm" ||
            ext == ".iklax" ||
            ext == ".ivs" ||
            ext == ".m4a" ||
            ext == ".m4b" ||
            ext == ".m4p" ||
            ext == ".mmf" ||
            ext == ".mpc" ||
            ext == ".msv" ||
            ext == ".nsf" ||
            ext == ".ogg" ||
            ext == ".oga" ||
            ext == ".mogg" ||
            ext == ".opus" ||
            ext == ".ra" ||
            ext == ".rm" ||
            ext == ".raw" ||
            ext == ".sln" ||
            ext == ".tta" ||
            ext == ".wav" ||
            ext == ".wma" ||
            ext == ".wv" ||
            ext == ".webm" ||
            ext == ".8svx"
          ) {
            return "Audio";
          }

          if (
            ext == ".mp4" ||
            ext == ".webm" ||
            ext == ".mkv" ||
            ext == ".flv" ||
            ext == ".vob" ||
            ext == ".ogv" ||
            ext == ".ogg" ||
            ext == ".drc" ||
            ext == ".gif" ||
            ext == ".gifv" ||
            ext == ".mng" ||
            ext == ".avi" ||
            ext == ".mov" ||
            ext == ".qt" ||
            ext == ".wmv" ||
            ext == ".yuv" ||
            ext == ".rm" ||
            ext == ".rmvb" ||
            ext == ".asf" ||
            ext == ".amv" ||
            ext == ".mp4" ||
            ext == ".m4p" ||
            ext == ".m4v" ||
            ext == ".mpg" ||
            ext == ".mp2" ||
            ext == ".mpeg" ||
            ext == ".mpe" ||
            ext == ".mpv" ||
            ext == ".mpg" ||
            ext == ".mpeg" ||
            ext == ".m2v" ||
            ext == ".m4v" ||
            ext == ".svi" ||
            ext == ".3gp" ||
            ext == ".3g2" ||
            ext == ".mxf" ||
            ext == ".roq" ||
            ext == ".nsv" ||
            ext == ".flv" ||
            ext == ".f4v" ||
            ext == ".f4p" ||
            ext == ".f4a" ||
            ext == ".f4b"
          ) {
            return "Video";
          }

          if (ext == ".jpg" || ext == ".png" || ext == ".gif") {
            return "Image File";
          }

          if (ext == ".txt") {
            return "Text Document";
          }
        }
      }
    },
    code(extname) {
      return (
        extname == ".xhtml" ||
        extname == ".html" ||
        extname == ".css" ||
        extname == ".java" ||
        extname == ".php" ||
        extname == ".js" ||
        extname == ".cs" ||
        extname == ".sql" ||
        extname == ".vue" ||
        extname == ".py" ||
        extname == ".cpp" ||
        extname == ".as" ||
        extname == ".h" ||
        extname == ".json" ||
        extname == ".rs" ||
        extname == ".r" ||
        extname == ".rb" ||
        extname == ".jsp"
      );
    },
    excel(extname) {
      return (
        extname == ".xls" ||
        extname == ".cvs" ||
        extname == ".csv" ||
        extname == ".xll" ||
        extname == ".xlsb" ||
        extname == ".xlam" ||
        extname == ".xlk" ||
        extname == ".xlsx" ||
        extname == ".xlsm" ||
        extname == ".xltm" ||
        extname == ".xltx"
      );
    },
    word(extname) {
      return extname == ".doc" || extname == ".docx";
    },
    audio(extname) {
      return (
        extname == ".mp3" ||
        extname == ".3pg" ||
        extname == ".aa" ||
        extname == ".aac" ||
        extname == ".aax" ||
        extname == ".act" ||
        extname == ".aiff" ||
        extname == ".amr" ||
        extname == ".ape" ||
        extname == ".au" ||
        extname == ".awb" ||
        extname == ".dct" ||
        extname == ".dss" ||
        extname == ".dvf" ||
        extname == ".flac" ||
        extname == ".gsm" ||
        extname == ".iklax" ||
        extname == ".ivs" ||
        extname == ".m4a" ||
        extname == ".m4b" ||
        extname == ".m4p" ||
        extname == ".mmf" ||
        extname == ".mpc" ||
        extname == ".msv" ||
        extname == ".nsf" ||
        extname == ".ogg" ||
        extname == ".oga" ||
        extname == ".mogg" ||
        extname == ".opus" ||
        extname == ".ra" ||
        extname == ".rm" ||
        extname == ".raw" ||
        extname == ".sln" ||
        extname == ".tta" ||
        extname == ".wav" ||
        extname == ".wma" ||
        extname == ".wv" ||
        extname == ".webm" ||
        extname == ".8svx"
      );
    },
    video(extname) {
      return (
        extname == ".mp4" ||
        extname == ".webm" ||
        extname == ".mkv" ||
        extname == ".flv" ||
        extname == ".vob" ||
        extname == ".ogv" ||
        extname == ".ogg" ||
        extname == ".drc" ||
        extname == ".gif" ||
        extname == ".gifv" ||
        extname == ".mng" ||
        extname == ".avi" ||
        extname == ".mov" ||
        extname == ".qt" ||
        extname == ".wmv" ||
        extname == ".yuv" ||
        extname == ".rm" ||
        extname == ".rmvb" ||
        extname == ".asf" ||
        extname == ".amv" ||
        extname == ".mp4" ||
        extname == ".m4p" ||
        extname == ".m4v" ||
        extname == ".mpg" ||
        extname == ".mp2" ||
        extname == ".mpeg" ||
        extname == ".mpe" ||
        extname == ".mpv" ||
        extname == ".mpg" ||
        extname == ".mpeg" ||
        extname == ".m2v" ||
        extname == ".m4v" ||
        extname == ".svi" ||
        extname == ".3gp" ||
        extname == ".3g2" ||
        extname == ".mxf" ||
        extname == ".roq" ||
        extname == ".nsv" ||
        extname == ".flv" ||
        extname == ".f4v" ||
        extname == ".f4p" ||
        extname == ".f4a" ||
        extname == ".f4b"
      );
    },
    format_date(val) {
      return moment(val).format("YYYY-MM-DD HH:MM:SS A");
    },
  },
};
</script>
